export enum ListBasketInsightSort {
  MostRevenue = 'Revenue',
  MostRecent = 'Date',
  Quantity = 'ItemsCount',
}

export interface IListBasketInsightQueryParams {
  listId: string;
  topN: number;
  sortBy: ListBasketInsightSort;
  fromDate?: string;
  toDate?: string;
}
